import { Pipe, PipeTransform } from '@angular/core';
import { BrowserStorageService } from '../services/storage.service';

@Pipe({ name: 'currencyReduce', pure: false })
export class CurrencyFormaterPipe implements PipeTransform {
    constructor(private browserStorageService?: BrowserStorageService) { }

    transform(amount: any, onlyReduce = false, echange_rate = 1): number {
        if (amount == null || amount == 0) {
            return 0;
        } else {
            if(onlyReduce) {
                return Number.parseFloat(((amount / 100) / echange_rate).toFixed(2));
            } else {
                let currency = this.browserStorageService.get("_currency");
                let currencyValue = Number.parseFloat(this.browserStorageService.get("_" + currency));
                return Number.parseFloat(((amount / 100) / currencyValue).toFixed(2));
            }


        }

    }

}
